import { InjectionKey } from 'vue'
import { createStore, MutationTree, ActionTree, GetterTree, useStore as baseUseStore, Store } from 'vuex'
import { RootState } from '@/types/store/index'
import { base } from './base'
import { layout } from './layout'
import { user } from './user'
import { contact } from './contact'
import { tag } from './tag'
import { video } from './video'
import { seminar } from './seminar'
import { menu } from './menu'
import { notice } from './notice'
import { search } from './search'

const getters: GetterTree<RootState, RootState> = {}

const mutations: MutationTree<RootState> = {}

const actions: ActionTree<RootState, RootState> = {}

export const key: InjectionKey<Store<RootState>> = Symbol()

export const store = createStore<RootState>({
  getters,
  mutations,
  actions,
  modules: {
    base,
    layout,
    user,
    contact,
    tag,
    video,
    seminar,
    menu,
    notice,
    search,
  }
})

export const useStore = (): Store<RootState> => {
  return baseUseStore(key)
}
